import { supabase } from "@/lib/supabase";

/** PostgREST table name for the Teil 3 consumer visibility view (types may lag migrations). */
export const CONSUMER_VISIBLE_VENUES = "consumer_visible_venues" as const;

const CACHE_TTL_MS = 5 * 60 * 1000;

type CacheEntry = { ids: string[]; expiresAt: number };
const cache = new Map<string, CacheEntry>();
const inflight = new Map<string, Promise<string[]>>();

function cacheKey(cityKey?: string): string {
  return cityKey?.trim().toLowerCase() || "__all__";
}

/** Drop cached venue-id lists (e.g. after admin visibility changes in the same session). */
export function invalidateConsumerVisibleVenueIdsCache(cityKey?: string): void {
  if (cityKey) cache.delete(cacheKey(cityKey));
  else cache.clear();
}

export async function fetchConsumerVisibleVenueIds(cityKey?: string): Promise<string[]> {
  const key = cacheKey(cityKey);
  const hit = cache.get(key);
  if (hit && hit.expiresAt > Date.now()) return hit.ids;

  const existing = inflight.get(key);
  if (existing) return existing;

  const promise = (async () => {
    let query = supabase.from(CONSUMER_VISIBLE_VENUES as "venues").select("id");
    if (cityKey) query = query.eq("city_key", cityKey);

    const { data, error } = await query;
    if (error) throw error;
    const ids = (data ?? []).map((row) => row.id as string);
    cache.set(key, { ids, expiresAt: Date.now() + CACHE_TTL_MS });
    return ids;
  })().finally(() => {
    inflight.delete(key);
  });

  inflight.set(key, promise);
  return promise;
}
